import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import { Table, TableContainer,TableHead, TableRow,TableBody, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

function createData(
  campo,
  pruebas,
  produccion
) {
  return { campo, pruebas, produccion };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.mode === 'dark' ? '#3399bf': '#576572',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Introduction = () => {
  const [t] = useTranslation('global');
  const rows = [
    createData(t('content.introduccion.tdAutentificacion'), "wsoauth-exp.rapifac.com", "wsoauth.rapifac.com"),
    createData(t('content.introduccion.tdEmision'), "wsventas-exp.rapifac.com", "wsventas.rapifac.com"),
    createData(t('content.introduccion.tdComprobantes'), "wscomprobante-exp.rapifac.com", "wscomprobante.rapifac.com"),
];
  return (
    <div id='intro'>
      
      <Typography variant="h3" gutterBottom>
        {t('content.introduccion.titulo')}
      </Typography>
      <Typography variant="body1" id="antesempezar" gutterBottom>
        {t('content.introduccion.dIntroduccion')}
      </Typography>
      <br/>
      <Typography variant="h5" gutterBottom>
        {/*t('content.introduccion.tEmpezar')*/}
      </Typography>
      <Typography variant="body1" id='requisitos' gutterBottom>
        {t('content.introduccion.dEmpezar')}
      </Typography>
      <br></br>
      <Typography variant="h5" gutterBottom>
        {t('content.introduccion.tAmbiente')}
      </Typography>
      
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{fontWeight: "bold", textTransform: 'uppercase'}} align="left"></StyledTableCell>
              <StyledTableCell sx={{fontWeight: "bold", textTransform: 'uppercase'}} align="left">{t('content.introduccion.thAmbientePruebas')}</StyledTableCell>
              <StyledTableCell sx={{fontWeight: "bold", textTransform: 'uppercase'}} align="left">{t('content.introduccion.thAmbienteProduccion')}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <StyledTableRow
                key={index}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <StyledTableCell align="left">{row.campo}</StyledTableCell>
                <StyledTableCell align="left">{row.pruebas}</StyledTableCell>
                <StyledTableCell align="left">{row.produccion}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
export default Introduction